import css from 'styled-jsx/css';

const drawerModalStyles = css`
  .custom-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
  }
  .custom-modal-drawer {
    position: fixed;
    background: #fff;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.18);
    display: flex;
    flex-direction: column;
    max-height: 100vh;
    outline: none;
  }
  .drawer-anchor-left {
    top: 0;
    left: 0;
    height: 100vh;
    border-radius: 0 8px 8px 0;
  }
  .drawer-anchor-right {
    top: 0;
    right: 0;
    height: 100vh;
    border-radius: 8px 0 0 8px;
  }
  .drawer-anchor-top {
    top: 0;
    left: 0;
    width: 100vw;
    border-radius: 0 0 8px 8px;
  }
  .drawer-anchor-bottom {
    bottom: 0;
    left: 0;
    width: 100vw;
    border-radius: 8px 8px 0 0;
  }
  .drawer-anchor-center {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: min(90vw, 500px);
    height: auto;
    border-radius: 12px;
  }
  .custom-drawer-content {
    flex: 1 1 auto;
    overflow: auto;
    min-height: 0;
  }
`;

export default drawerModalStyles;
